import { render, staticRenderFns } from "./Projections.vue?vue&type=template&id=77170b52"
import script from "./Projections.vue?vue&type=script&lang=js"
export * from "./Projections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports